import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/driver";
const driversQuery = {
    orderBy: ["id desc"],
};

export const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...driversQuery });
    return request(
        `${resource}/getlist?checkOnline=true&withDeleted=true&${query.substr(1)}`,
        { method: "GET" },
        { countInHeaders: true },
    );
};
export const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...driversQuery });
    return request(
        `${resource}/getListExcel?withDeleted=true&${query.substr(1)}`,
        { method: "GET" },
        { withoutMiddleware: true },
    ).then((res) => downloadFileHandler(res, "Водители.xlsx"));
};
export const filteredNamesList = (params: {}, ids: number[]) =>
    request(`${resource}/getNamesList${containsQuery(params, { filter: { id: { in: ids } } })}`, { method: "GET" });

export const list = (params: {}) =>
    request(`${resource}/getlist${containsQuery(params)}&withDeleted=true`, { method: "GET" });
export const namesList = (params: {}) => request(`${resource}/getNamesList${containsQuery(params)}`, { method: "GET" });
export const namesListWithDeleted = (params: {}) =>
    request(`${resource}/getNamesList${containsQuery(params)}&withDeleted=true`, { method: "GET" });
export const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
export const getItem = (params: { id: number }) => request(`${resource}/getForEdit?id=${params.id}`, { method: "GET" });
export const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));
export const sendSms = (params: {}) => alertRequest(`${resource}/sendPasswordSms`, body(params));
export const setResourceActivity = (params: {}) => alertRequest(`${resource}/setResourceActivity`, body(params));
export const restore = (params: {}) => alertRequest(`${resource}/restore`, body(params));
export const setPassportData = (params: {}) => alertRequest(`${resource}/setPassportData`, body(params));
export const deletePassportData = (params: {}) => alertRequest(`${resource}/deletePassportData`, body(params));
export const getPassportData = (id: number) => request(`${resource}/getPassportData/${id}`, { method: "GET" });
export const setDriverLicense = (params: {}) => alertRequest(`${resource}/setDriverLicense`, body(params));
export const deleteDriverLicense = (params: {}) => alertRequest(`${resource}/deleteDriverLicense`, body(params));
export const getDriverLicense = (id: number) => request(`${resource}/getDriverLicense/${id}`, { method: "GET" });
